import { sendToMixpanel, getUserProps } from '../mixpanel';
import { SearchTypeView, SearchAgentType } from './enums';
import getEntryPoint from '../get-entry-point';

export interface ViewSearchResultsProps {
  suburb?: string | null;
  searchTypeView?: SearchTypeView;
  searchSortBy?: string;
  searchFilterSuburb?: string[];
  searchFilterAgentType?: SearchAgentType;
  searchResultsReturnedCount?: number;
  searchResultsPageDepth?: number;
}

/**
 * Track View FAA Search Results event
 * Captures granular search criteria and results information
 */
function trackViewSearchResultsPage(props: ViewSearchResultsProps = {}): void {
  const {
    suburb,
    searchTypeView,
    searchSortBy,
    searchFilterSuburb = [],
    searchFilterAgentType,
    searchResultsReturnedCount,
    searchResultsPageDepth,
  } = props;

  const entryPoint = getEntryPoint();

  const eventProps = {
    ...(entryPoint && { entryPoint }),
    ...(suburb && { suburb }),
    ...(searchTypeView && { searchTypeView }),
    ...(searchSortBy && { searchSortBy }),
    ...(searchFilterSuburb.length > 0 && { searchFilterSuburb }),
    ...(searchFilterAgentType && { searchFilterAgentType }),
    ...(typeof searchResultsReturnedCount === 'number' && {
      searchResultsReturnedCount,
    }),
    ...(typeof searchResultsPageDepth === 'number' && {
      searchResultsPageDepth,
    }),
    ...getUserProps(),
  };

  // Base props supply pageType, primaryCategory, subCategory1, pageName and
  // the lastTouchUTM* values (see mixpanel.ts getBaseProps)
  sendToMixpanel('View FAA Search Results', eventProps);
}

export default trackViewSearchResultsPage;
